
import { BlogSection } from '@/types/blog';

export const fazit: BlogSection = {
  id: 'fazit',
  title: 'Fazit: Die Kunst, den richtigen Begleiter zu finden',
  content: `
<p class="mb-4">
  Wenn Sie nach Beratung, Coaching oder Führung suchen – sei es im Bereich der Finanzen, der persönlichen Entwicklung oder in anderen Lebensbereichen – nehmen Sie sich Zeit, um zu beobachten und hinzuhören.
</p>

<div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
  <div class="bg-white p-5 rounded-xl shadow-soft">
    <h3 class="text-lg font-medium mb-3">Achten Sie auf diese Warnzeichen:</h3>
    <ul class="list-disc pl-5 space-y-2">
      <li>Absolute Aussagen ohne Nuancen</li>
      <li>Fehlende Bereitschaft, eigene Grenzen einzugestehen</li>
      <li>Übermäßiger Fokus auf Selbstdarstellung statt auf Ihr Anliegen</li>
      <li>Versprechen von schnellen, mühelosen Ergebnissen</li>
      <li>Druck, sofort zu entscheiden oder zu handeln</li>
    </ul>
  </div>
  
  <div class="bg-white p-5 rounded-xl shadow-soft">
    <h3 class="text-lg font-medium mb-3">Suchen Sie nach diesen Qualitäten:</h3>
    <ul class="list-disc pl-5 space-y-2">
      <li>Echtes Zuhören und Eingehen auf Ihre spezifische Situation</li>
      <li>Transparenz über Grenzen des eigenen Wissens</li>
      <li>Bereitschaft, "Ich weiß es nicht" zu sagen, wenn es angebracht ist</li>
      <li>Fokus auf Prozess und nachhaltiges Lernen statt schnelle Lösungen</li>
      <li>Respekt für Ihre Autonomie und Entscheidungsfähigkeit</li>
    </ul>
  </div>
</div>

<p class="mb-4">
  Als Finanzcoach strebe ich danach, in die fünfte Kategorie zu fallen – nicht als jemand, der alle Antworten hat, sondern als jemand, der weiß, wie man die richtigen Fragen stellt und einen Raum schafft, in dem echtes Lernen und nachhaltige Entwicklung möglich sind.
</p>

<p class="mb-8">
  Und wenn ich in einem Bereich nicht über ausreichendes Wissen verfüge, sage ich das offen und suche gemeinsam mit meinen Klienten nach den richtigen Ressourcen und Experten.
</p>

<div class="bg-joerg-700 text-white p-6 rounded-xl my-8">
  <p class="text-center text-xl">
    🔹 Wähle weise, mit wem du gehst. 🔹
  </p>
</div>

<div class="mt-8 pt-6 border-t border-joerg-100">
  <p class="text-sm text-joerg-500">
    📖 Basierend auf einer alten persischen Weisheit (persische Quelle: "Man 'araf nafsahu, 'araf rabbahu" - Quelle: Suhrawardi, persischer Philosoph & Mystiker des 12. Jh.).
  </p>
  <p class="text-sm text-joerg-500 mt-1">
    ✍ Adaptierte Fassung: Jörg Hörmann
  </p>
</div>
  `,
};
